import { useState } from "react";
import { MapPin, Clock, ArrowUpRight } from "lucide-react";
import { SHOWROOMS, mapsEmbedUrl } from "@/data/showrooms";
import { Reveal } from "@/components/Motion";

export default function ShowroomMap() {
  const [active, setActive] = useState(SHOWROOMS[0]);

  return (
    <Reveal>
      <p className="text-xs tracking-[0.3em] uppercase text-secondary-foreground mb-3">Visit us</p>
      <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-light tracking-tight mb-10">
        Find your <span className="italic">nearest</span> showroom.
      </h2>

      <div className="flex flex-wrap gap-3 mb-6">
        {SHOWROOMS.map((s) => (
          <button
            key={s.id}
            data-testid={`map-tab-${s.id}`}
            onClick={() => setActive(s)}
            className={`w-full sm:w-auto text-center text-xs tracking-[0.18em] uppercase px-5 py-3.5 border transition-colors duration-300 ${
              active.id === s.id
                ? "bg-primary text-primary-foreground border-primary"
                : "border-border text-secondary-foreground hover:border-foreground"
            }`}
          >
            {s.label} — {s.name}
          </button>
        ))}
      </div>

      <iframe
        key={active.id}
        title={`Map — ${active.name}`}
        data-testid="showroom-map-embed"
        src={mapsEmbedUrl(active)}
        className="w-full h-[340px] md:h-[440px] border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />

      <div className="border border-t-0 border-border p-6 flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="text-sm font-light text-muted-foreground flex items-start gap-2.5 max-w-md" data-testid="map-active-address">
            <MapPin className="w-4 h-4 mt-0.5 shrink-0" /> {active.address}
          </p>
          <p className="mt-2 text-sm font-light text-muted-foreground flex items-center gap-2.5">
            <Clock className="w-4 h-4 shrink-0" /> Open daily till 7:00 PM
          </p>
        </div>
        <a
          href={active.link}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="map-directions-link"
          className="group inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase"
        >
          <span className="border-b border-foreground/40 pb-1 transition-colors duration-300 group-hover:border-foreground">
            Get directions
          </span>
          <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
    </Reveal>
  );
}
